import { FC, JSX } from "react";
import { Text } from "@radix-ui/themes";
import { Profile } from "@/models/Profile.model";

const ProfileBiography: FC<Partial<Profile>> = ({ about }): JSX.Element => {
  if (about) {
    return (
      <Text as="p" size="2">
        {about}
      </Text>
    );
  }

  return <></>;
};

export default ProfileBiography;
